import { TranslationKey } from './../../../../../types/translation/TranslationKey';

import React, { useContext } from 'react';
import { t } from '../../../../../types/translation/Translator';
import { StockLocation } from '../../../../../types/stock_location/stockLocation';
import { StockLocationContext } from '../../../../../context/StockLocationContext';

import InnerFilterContent, { FilterInnerContentProps } from '../../common/DropdownContent/DynamicFilterInnerContent';
import { StockLocationFilterMode } from '../StockLocationFilter';
import type { StockLocationFilterMode as StockLocationFilterModeType } from '../StockLocationFilter';

export default function StockLocationFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
  mode = StockLocationFilterMode.all,
}: FilterInnerContentProps<StockLocation> & { mode?: StockLocationFilterModeType }) {
  const { stockLocations } = useContext(StockLocationContext);

  const getSelectedStockLocations = () => {
    switch (mode) {
      case StockLocationFilterMode.source:
        return filterProps.sourceStockLocation;
      case StockLocationFilterMode.destination:
        return filterProps.destinationStockLocation;
      case StockLocationFilterMode.all:
        return filterProps.stockLocation;
    }
  };

  const selectedStockLocations = getSelectedStockLocations();

  return (
    <InnerFilterContent
      filterProps={{ filterProps, setFilterProps }}
      filter={filter}
      items={[...(selectedStockLocations || [])]}
      text={item => stockLocations.get(item)?.name || t(TranslationKey.unknownStockLocation).singular.label}
      onRemove={i => {
        switch (mode) {
          case StockLocationFilterMode.source:
            filterProps.sourceStockLocation?.delete(i);
            if (!filterProps.sourceStockLocation?.size) filterProps.sourceStockLocation = undefined;
            break;
          case StockLocationFilterMode.destination:
            filterProps.destinationStockLocation?.delete(i);
            if (!filterProps.destinationStockLocation?.size) filterProps.destinationStockLocation = undefined;
            break;
          case StockLocationFilterMode.all:
            filterProps.stockLocation?.delete(i);
            if (!filterProps.stockLocation?.size) filterProps.stockLocation = undefined;
            break;
        }

        setFilterProps({ ...filterProps });
      }}
    />
  );
}
